import { registerSetupCode } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import type { BoardType } from '@/(routers)/boards/editor/block/blockConfig';

const _sdcardFiles = new Map<string, string>();
let _sdcardBeginRegistered = false;

export function sdcardUsed(): boolean {
    return _sdcardFiles.size > 0;
}

export function resetSdcard(): void {
    _sdcardFiles.clear();
    _sdcardBeginRegistered = false;
}

export function registerSdcardFile(filename: string, mode: string, board: BoardType): string {
    if (_sdcardFiles.has(filename)) {
        return _sdcardFiles.get(filename)!;
    }
    const varName = `_sbeFile_${_sdcardFiles.size}`;
    _sdcardFiles.set(filename, varName);

    if (!_sdcardBeginRegistered) {
        // ブルー(ESP32)はCS=4が未配線のためCS=5を使用、VSPIバスの明示指定が必須
        const beginCode =
            board === 'blue'
                ? [
                      '  SPI.begin(18, 19, 23, 5);',
                      '  if (!SD.begin(5, SPI, 10000000)) { Serial.println("[SDカード] 初期化失敗"); return; }',
                  ].join('\n') + '\n'
                : `  if (!SD.begin(4)) { Serial.println("[SDカード] 初期化失敗"); return; }\n`;
        registerSetupCode('sdcard_begin', beginCode);
        _sdcardBeginRegistered = true;
    }

    if (mode === 'NEW') {
        registerSetupCode(
            `sdcard_${filename}`,
            [
                `  if (SD.exists(${filename})) SD.remove(${filename});`,
                `  ${varName} = SD.open(${filename}, FILE_WRITE);`,
                `  if (!${varName}) Serial.println("[SDカード] ファイルオープン失敗");`,
            ].join('\n') + '\n',
        );
    } else {
        registerSetupCode(
            `sdcard_${filename}`,
            [
                `  if (${varName}) ${varName}.close();`,
                `  ${varName} = SD.open(${filename}, FILE_WRITE);`,
                `  if (!${varName}) Serial.println("[SDカード] ファイルオープン失敗");`,
            ].join('\n') + '\n',
        );
    }

    return varName;
}

export function getSdcardGlobalCode(): string {
    if (_sdcardFiles.size === 0) return '';
    return [..._sdcardFiles.values()].map((v) => `File ${v};\n`).join('');
}
